export interface ExchangeDeviceCodeResponse {
	/**
	 * Token used for authorization refresh.
	 */
	refresh_token: string;
	/**
	 * Token identifying the device.
	 */
	id_token: string;
	/**
	 * Authorization token type.
	 */
	token_type: string;
}

export interface GetDeviceCodeResponse {
	device_code: string;
	user_code: string;
	verification_uri: string;
	verification_uri_complete: string;
	expires_in: number;
	interval: number;
}

/**
 * Requests a device code for pairing.
 * @param pairingUrl The pairing (wizard) URL where the device will be created.
 * @returns Resolves with the device code and data about its expiration.
 */
export const requestDeviceCode = async (
	pairingUrl: string
): Promise<GetDeviceCodeResponse> => {
	console.log('in request device code');
	const url = `${pairingUrl}/oauth/device/code`;
	const response = await fetch(url, {
		method: 'POST',
		headers: { 'X-Requested-With': 'XMLHttpRequest' },
	});
	return response.json();
};
